var _style, _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1244.17 905.7",
    style: {
      enableBackground: "new 0 0 1244.17 905.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;}\r\n\t.st1{fill:#EFF1FD;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{display:none;}\r\n\t.st4{display:inline;}\r\n\t.st5{fill:url(#SVGID_1_);}\r\n\t.st6{fill:url(#SVGID_2_);}\r\n\t.st7{fill:#6883DE;}\r\n\t.st8{fill:url(#SVGID_3_);}\r\n\t.st9{fill:url(#SVGID_4_);}\r\n\t.st10{fill:url(#SVGID_5_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "bg_x5F_obj"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,621.45c220.11-22.03,391.97-207.8,391.97-433.72C391.97-38.18,220.11-223.95,0-245.98L0,621.45z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.67-243.84c-2.66-0.38-5.33-0.73-8.01-1.06L0-196.81v40.96L17.67-243.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.7-238.3c-2.62-0.57-5.26-1.12-7.9-1.64L0-36.81L0,4.15L48.7-238.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.27-230.51c-2.58-0.76-5.18-1.5-7.78-2.21L0,123.2v40.96L79.27-230.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.38-220.44c-2.54-0.96-5.1-1.89-7.67-2.8L0,283.2v40.96L109.38-220.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.02-208.02c-2.5-1.16-5.01-2.3-7.54-3.41L0,443.2v40.96L139.02-208.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.76-197.21L0,603.21v18.25c1.56-0.16,3.11-0.32,4.66-0.49l163.51-814.12 C165.72-194.54,163.24-195.88,160.76-197.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.8-175.72c-2.41-1.6-4.84-3.17-7.28-4.72L29.26,617.51c2.85-0.48,5.7-0.99,8.53-1.53L196.8-175.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M224.87-155.44c-2.36-1.85-4.73-3.67-7.13-5.47L62.81,610.46c2.91-0.73,5.8-1.49,8.68-2.28L224.87-155.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.3-132.03c-2.3-2.13-4.62-4.23-6.96-6.31L96.98,600.35c2.97-1.01,5.92-2.06,8.86-3.13L252.3-132.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.02-105.04c-2.23-2.46-4.48-4.88-6.76-7.29l-140.4,699.07c3.04-1.34,6.05-2.71,9.05-4.12L279.02-105.04z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.87-73.74c-2.14-2.85-4.32-5.68-6.52-8.48l-130.79,651.2c3.12-1.74,6.22-3.51,9.3-5.32L304.87-73.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.63-37.02c-2.03-3.37-4.1-6.71-6.22-10.01L204.28,546.11c3.23-2.24,6.44-4.53,9.61-6.86L329.63-37.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.9,7.11c-1.87-4.09-3.79-8.16-5.78-12.18L242.38,516.42c3.39-2.96,6.74-5.97,10.04-9.03L352.9,7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M373.83,62.91c-1.59-5.32-3.27-10.59-5.05-15.82L282.51,476.6c3.67-4.14,7.25-8.35,10.76-12.63L373.83,62.91 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M389.76,143.6c-0.84-8.37-1.92-16.67-3.23-24.89L326.5,417.6c4.38-7.05,8.57-14.23,12.55-21.54L389.76,143.6 z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9701.4268,
    y1: -663.8658,
    x2: 10164.4141,
    y2: -663.8658,
    gradientTransform: "matrix(-0.9636 0.2673 0.2673 0.9636 9980.6289 -1182.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF636E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98D6C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.12,899.13l-284.76,0.25c3.29-18.96,11.46-41.42,27.92-67.19c171.71-125.82,341.14-102.99,401.43-76.12 C404.58,821.08,354.73,866.9,306.12,899.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.45,765.73c-9.36,2.89-18.71,5.78-28.07,8.67c8.02,7.91,16.99,14.73,26.62,20.38 c-0.81,0.97-1.61,1.93-2.42,2.89c-10.23-6.07-19.75-13.44-28.25-22.01c-12.09,3.73-24.18,7.47-36.26,11.2 c-0.37,0.37-0.91,0.51-1.45,0.45c-10.28,3.18-20.56,6.35-30.84,9.54c-1.12,0.35-2.23,0.7-3.35,1.05 c9.28,15.94,24.7,26.59,40.84,34.82c6.07,3.09,12.28,5.96,18.57,8.63c-1.09,1.05-2.18,2.09-3.27,3.13 c-23.88-9.82-47.18-23.46-59.8-45.42c-20.66,6.5-41.15,13.38-61.46,20.75c20.32,28.62,53.33,43.62,85.71,55.49 c-1.16,0.91-2.31,1.82-3.47,2.71c-32.63-12.16-65.68-27.64-85.91-56.86c-8.85,3.24-17.67,6.57-26.45,10.01 c-0.05,0.06-0.11,0.12-0.16,0.19c-0.54,0.65-1.26,0.78-1.9,0.62c-5.39,2.12-10.76,4.29-16.12,6.5 c21.64,23.57,46.48,43.95,73.54,60.69l-7.04,0.01c-25.76-16.55-49.43-36.4-70.18-59.15c-14.48,6.03-28.85,12.34-43.09,19.05 c-3.35,1.58-6.7,3.18-10.04,4.79c6.57,13.45,15.6,25.12,26.14,35.39l-5.25,0c-9.7-9.89-18.03-21.03-24.28-33.74 c-14.43,7.04-28.71,14.4-42.82,22.05c1.46,4.01,3.09,7.92,4.86,11.74l-4.15,0c-1.46-3.24-2.82-6.54-4.05-9.91 c-5.94,3.25-11.85,6.57-17.73,9.93l-7.65,0.01c4.9-2.84,9.81-5.64,14.76-8.41c21.75-12.15,43.91-23.58,66.43-34.25 c21.5-38.85,46.65-75.49,75.05-109.47c2.02-0.48,4.04-0.95,6.04-1.4c-28.44,33.54-53.67,69.76-75.25,108.13 c12.94-6.04,26.01-11.81,39.18-17.36c0.4-0.86,1.53-1.43,2.53-1.07c6.38-2.67,12.77-5.3,19.2-7.85 c27.17-32.2,56.05-62.9,86.51-91.97c1.94-0.11,3.86-0.21,5.77-0.29c-29.83,28.26-58.16,58.08-84.86,89.35 c5.4-2.1,10.81-4.16,16.24-6.18c34.89-12.92,70.42-24.15,106.05-35.02c1.14-17.87,8.53-33.15,18.87-46.68 c1.48,0.14,2.93,0.3,4.38,0.46c-10.34,13.04-17.88,27.77-19.4,45.04c22.1-6.73,44.22-13.34,66.25-20.14 C423.32,761.52,424.78,765.01,422.45,765.73z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 10296.3662,
    y1: 470.4203,
    x2: 10163.0254,
    y2: 38.855,
    gradientTransform: "matrix(-0.996 0.0893 0.0893 0.996 10213.7285 -512.9358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF636E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98D6C"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.41,514.36c23.83-36.37,49.17-61.55,67.92-74.73c117.81,267.65-21.19,442.31-26.17,449.72 c0,0-17.8,3.4-41.43-7.31L0.41,514.36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.66,802.34c0.75-22.79,2.21-45.55,4.4-68.25c-1.51-2.6-3-5.21-4.47-7.82l-0.01-7.47 c1.68,3.05,3.37,6.08,5.1,9.11c1.4-13.68,3.09-27.33,5.02-40.94c-0.51-0.75-0.43-1.97,0.37-2.62c0.95-6.59,1.93-13.17,3-19.74 c-4.8-13.98-9.32-28.06-13.57-42.21l-0.01-12.95c4.6,15.97,9.54,31.84,14.85,47.6c0.94-5.5,1.9-10.99,2.92-16.47 c6.56-35.2,14.84-70.1,23.46-104.91c-14.19-9.77-23.17-23.42-29.24-38.65c0.85-1.15,1.7-2.28,2.54-3.39 c5.66,14.98,14.1,28.49,27.63,38.28c5.36-21.58,10.83-43.12,16.09-64.68c0.55-2.26,4.15-1.74,3.6,0.53 c-2.23,9.16-4.47,18.32-6.7,27.47c10.5-2.72,20.56-6.76,29.98-11.92c0.4,1.14,0.8,2.28,1.19,3.42 c-10.07,5.46-20.86,9.68-32.14,12.46c-2.89,11.83-5.77,23.66-8.66,35.49c0.12,0.49-0.03,1.01-0.35,1.42 c-2.45,10.06-4.91,20.12-7.35,30.19c-0.27,1.1-0.52,2.19-0.79,3.29c17.76,0.21,34.17-7.26,48.94-16.53 c5.56-3.49,10.99-7.2,16.3-11.08c0.33,1.42,0.65,2.84,0.97,4.25c-19.91,14.87-42.69,27.39-67.07,26.96 c-4.83,20.28-9.27,40.61-13.22,61.02c33.68-2.64,62.38-22.5,88.18-43.39c0.18,1.41,0.36,2.81,0.53,4.21 c-26.17,20.95-55.28,40.6-89.42,42.88c-1.7,8.92-3.31,17.84-4.8,26.8c0.03,0.07,0.05,0.15,0.08,0.22 c0.27,0.77,0.02,1.43-0.43,1.88c-0.91,5.5-1.77,11.01-2.59,16.52c35.42-7.31,69.4-20.44,100.53-38.45 c0.02,1.39,0.03,2.77,0.04,4.15C84.21,666.9,50.05,679.9,14.45,687.13c-2.18,14.94-4.06,29.93-5.55,45.01 c-0.35,3.55-0.68,7.11-1,10.66c37.14,3.15,72.58-13.13,103.66-32.24c-0.21,1.55-0.43,3.09-0.66,4.62 c-31.17,18.75-66.25,34.31-103.3,31.24c-1.31,15.4-2.29,30.83-2.94,46.27c30.6,5.9,61.34,1.42,90.24-8.87 c-0.47,1.47-0.95,2.91-1.43,4.35c-28.57,9.79-58.87,13.91-88.95,8.19c-0.86,22.44-1.01,44.91-0.48,67.37 c8.52-0.42,17.04,0.03,25.56-0.27c9.56-0.34,18.97-1.98,28.18-4.52c1.65-0.45,3.3-0.94,4.95-1.44c-0.88,1.56-1.75,3.06-2.6,4.51 c-1.06,0.29-2.11,0.61-3.17,0.89c-17.67,4.64-34.84,3.51-52.83,4.46c0.15,5.46,0.34,10.92,0.57,16.38 c-1.22-0.49-2.45-1.01-3.7-1.57c-0.1-2.52-0.19-5.04-0.28-7.57L0.66,802.34z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.39,899.33L0.75,899.4L0.6,729.36C105,616.68,228.05,588.08,282.69,590.05 C241.97,760.91,149.69,852.16,77.39,899.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6,845.36c-1.78,2.17-3.53,4.37-5.29,6.56L0.7,845.9c14.42-17.69,29.35-34.97,44.82-51.75 c5.41-44.07,15.03-87.45,28.67-129.59c1.69-1.2,3.39-2.39,5.08-3.56c-13.84,41.74-23.69,84.77-29.35,128.43 c9.74-10.45,19.71-20.68,29.85-30.75c0.05-0.95,0.88-1.9,1.95-1.94c4.92-4.86,9.87-9.69,14.87-14.46 c13.16-40.02,28.47-79.3,45.84-117.65c1.75-0.82,3.5-1.63,5.25-2.42c-17.1,37.37-32.22,75.62-45.29,114.6 c4.22-3.96,8.47-7.9,12.75-11.8c27.53-25.03,56.28-48.73,85.26-72.14c-5.62-17-4.49-33.93,0.05-50.35 c1.42-0.42,2.83-0.82,4.24-1.21c-4.71,15.96-6.2,32.44-1.14,49.03c17.98-14.5,36.03-28.91,53.91-43.46 c1.87-1.52,4.53,1.16,2.64,2.7c-7.6,6.18-15.19,12.36-22.79,18.54c10.4,4.34,21.26,7.31,32.3,8.95c-0.38,1.2-0.77,2.39-1.16,3.58 c-11.76-1.8-23.34-5.08-34.43-9.85c-9.81,7.98-19.63,15.97-29.44,23.95c-0.21,0.48-0.66,0.82-1.18,0.96 c-8.34,6.79-16.69,13.58-25.03,20.38c-0.91,0.74-1.81,1.49-2.71,2.23c14.57,11.32,32.85,15.43,50.9,17.03 c6.79,0.6,13.61,0.94,20.44,1.06c-0.62,1.38-1.24,2.76-1.86,4.12c-25.82-0.18-52.53-4.11-72.45-19.77 c-16.73,13.75-33.16,27.8-49.24,42.23c29.54,18.94,65.77,20.51,100.24,19.41c-0.73,1.28-1.47,2.55-2.21,3.81 c-34.81,0.92-71.25-1.07-100.94-20.61c-7,6.32-13.94,12.7-20.79,19.17c-0.03,0.08-0.05,0.15-0.08,0.23 c-0.26,0.8-0.88,1.2-1.53,1.29c-4.2,3.98-8.37,8-12.52,12.05c33.92,16.17,70.29,26.63,107.37,31.25 c-0.86,1.16-1.71,2.31-2.57,3.46c-37.19-4.87-73.63-15.54-107.64-31.89c-11.18,11-22.15,22.24-32.84,33.78 c-2.52,2.72-5.02,5.45-7.52,8.2c28.77,25.91,68.33,34.67,106.06,38.35c-1.15,1.15-2.29,2.28-3.44,3.41 c-37.57-4.04-76.38-13.17-105.14-38.96c-10.75,11.93-21.24,24.09-31.47,36.47c21.63,24.08,49.89,39.67,80.28,49.28 c-1.31,0.92-2.62,1.82-3.92,2.7C54.99,884.58,27.31,868.97,6,845.36z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.1083,
    y1: 760.4992,
    x2: 637.1083,
    y2: 784.5637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF636E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98D6C"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M619.77,774.6c0-9.56,7.78-17.34,17.34-17.34c9.56,0,17.34,7.78,17.34,17.34s-7.78,17.34-17.34,17.34 C627.55,791.94,619.77,784.16,619.77,774.6z M627.52,774.6c0,5.29,4.3,9.59,9.59,9.59c5.29,0,9.59-4.3,9.59-9.59 c0-5.29-4.3-9.59-9.59-9.59C631.82,765.01,627.52,769.31,627.52,774.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.7559,
    y1: 271.3973,
    x2: 389.7559,
    y2: 295.4618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF636E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98D6C"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372.42,285.5c0-9.56,7.78-17.34,17.34-17.34c9.56,0,17.34,7.78,17.34,17.34s-7.78,17.34-17.34,17.34 C380.19,302.84,372.42,295.06,372.42,285.5z M380.17,285.5c0,5.29,4.3,9.59,9.59,9.59c5.29,0,9.59-4.3,9.59-9.59 c0-5.29-4.3-9.59-9.59-9.59C384.47,275.91,380.17,280.21,380.17,285.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1019.4757,
    y1: 235.4356,
    x2: 1019.4757,
    y2: 259.5001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF636E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F98D6C"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1002.14,249.54c0-9.56,7.78-17.34,17.34-17.34c9.56,0,17.34,7.78,17.34,17.34s-7.78,17.34-17.34,17.34 C1009.91,266.88,1002.14,259.1,1002.14,249.54z M1009.89,249.54c0,5.29,4.3,9.59,9.59,9.59c5.29,0,9.59-4.3,9.59-9.59 c0-5.29-4.3-9.59-9.59-9.59C1014.19,239.95,1009.89,244.25,1009.89,249.54z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M146.75,747.32l0-29.28c0-1.24-1.01-2.24-2.24-2.24s-2.24,1.01-2.24,2.24l0,29.28c0,1.24,1.01,2.24,2.24,2.24 S146.75,748.56,146.75,747.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M159.14,730.43h-29.28c-1.24,0-2.24,1.01-2.24,2.24c0,1.24,1.01,2.24,2.24,2.24h29.28 c1.24,0,2.24-1.01,2.24-2.24C161.39,731.44,160.38,730.43,159.14,730.43z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M849.85,84.61V61.7c0-0.97-0.79-1.76-1.76-1.76c-0.97,0-1.76,0.79-1.76,1.76v22.91 c0,0.97,0.79,1.76,1.76,1.76C849.06,86.37,849.85,85.58,849.85,84.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M859.55,71.4h-22.91c-0.97,0-1.76,0.79-1.76,1.76c0,0.97,0.79,1.76,1.76,1.76h22.91 c0.97,0,1.76-0.79,1.76-1.76C861.31,72.19,860.52,71.4,859.55,71.4z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1008.02,850.91V828c0-0.97-0.79-1.76-1.76-1.76c-0.97,0-1.76,0.79-1.76,1.76v22.91 c0,0.97,0.79,1.76,1.76,1.76C1007.23,852.66,1008.02,851.88,1008.02,850.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1017.72,837.7l-22.91,0c-0.97,0-1.76,0.79-1.76,1.76c0,0.97,0.79,1.76,1.76,1.76h22.91 c0.97,0,1.76-0.79,1.76-1.76C1019.48,838.48,1018.69,837.7,1017.72,837.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.98ebd5f975faec06a99e986a04e124af.svg";
export { ForwardRef as ReactComponent };